<template>
  <div class="hello" v-show="dialogTableVisible">
    <div class="head flex">
      <span class="school_name">
        北京大学
      </span>
      <div class="info">
        <span>录取概率</span>
        <span style="color: #FEA12C;">60%较稳妥</span>
      </div>
      <div class="info">
        <span>招生代码</span>
        <span>1220</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    props: {
      dialogTableVisible: ''
    },
    created() {

    }
  }
</script>

<style scoped lang="scss">
  .head {
    height: 56px;
    border-bottom: 1px solid #E6E6E6;

    .info {
      margin-right: 34px;
    }

    .info>span:nth-child(1) {
      color: #999999;
    }

    .info>span:nth-child(2) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }

    .school_name {
      font-size: 16px;
      margin: 0 87px 0 27px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }

  .hello {
    width: 1200px;
    height: 654px;
    background: #FFFFFF;
    border-radius: 10px;
    position: absolute;
    z-index: 1000;
    top: 50%;
    left: 50%;
    margin-left: -600px;
    margin-top: -327px;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup.vue